import React from "react";
import { motion } from "framer-motion";

const LINKS = [
    { id: "work", label: "Work" },
    { id: "about", label: "About" },
    { id: "services", label: "Services" },
    { id: "stories", label: "Stories" },
    { id: "process", label: "Process" },
    { id: "faq", label: "FAQ" },
    { id: "contact", label: "Contact" },
];

export function NavBar() {
    function jump(id) {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    return (
        <motion.nav
            data-testid="top-nav"
            initial={{ opacity: 0, y: -16, x: "-50%" }}
            animate={{ opacity: 1, y: 0, x: "-50%" }}
            transition={{ duration: 0.7, delay: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
            className="fixed top-3 md:top-5 left-1/2 z-50 max-w-[94vw]"
        >
            <div
                className="flex items-center gap-1 md:gap-2 rounded-full border px-2 py-1.5 md:px-3 md:py-2 overflow-x-auto"
                style={{
                    borderColor: "var(--line)",
                    background: "rgba(12,12,12,0.72)",
                    backdropFilter: "blur(16px)",
                    WebkitBackdropFilter: "blur(16px)",
                    scrollbarWidth: "none",
                }}
            >
                {LINKS.map((l) => (
                    <button
                        key={l.id}
                        type="button"
                        data-testid={`nav-link-${l.id}`}
                        onClick={() => jump(l.id)}
                        className="rounded-full px-3 py-1.5 md:px-4 md:py-2 text-sm md:text-base uppercase tracking-[0.18em] whitespace-nowrap transition-colors hover:bg-white/5 hover:text-[var(--accent)]"
                        style={{ color: "var(--text)" }}
                    >
                        {l.label}
                    </button>
                ))}
            </div>
        </motion.nav>
    );
}
